module.exports = __webpack_public_path__ + "static/media/top_arrow_indicator_icon.20c949ae.svg";